import "../../../../src/App.css";
import React, { useState, useEffect } from "react";
import axios from "axios";
import MiniDrawer from "../../../components/MiniDrawer/MiniDrawer";
import Wrapper from "../../../components/UI/Wrapper";
import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
import  "../../../pages/LeadDataReportMaster/LeadDataReportMaster.css";
import PaymentList from "../../../components/PaymentList/PaymentList";


function PaymentConfirmation() {
  const [openProfile, setOpenProfile] = useState(false);
 
  return (
    <>
      <div className="d-flex flex-row app">
        <MiniDrawer />
       
        <div
          className="container-fluid"
          style={{ padding: "4rem 1rem 1rem 1rem", backgroundColor: "#F4F4F4", width: "100%", overflowX: "auto" }}
        >
          <div
            className="d-flex flex-column w-100"
            style={{ backgroundColor: "#F4F4F4" }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
                marginTop: "1%",
              }}
            >
              <div>
                <h1 style={{ fontSize: "24px", marginBottom: "2rem" }}>
                Payment Confirmation | <HomeOutlinedIcon />{" "}
                  <span style={{ fontSize: "20px" }}>&gt; Accounts & Finance</span>
                  <span style={{ fontSize: "20px" }}>&gt; Sales Register</span>
                  <span style={{ fontSize: "20px" }}>&gt; Payment Confirmation</span>
                </h1>
              </div>
              
            </div>
            <div> 
            <Wrapper className="ViewLeadDetails wrapperLeadDataReport" >                 
                       
                <PaymentList />      
              </Wrapper>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default PaymentConfirmation;
